var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.ribbon_can('nfc_admin_list') &&
      !_vm.ribbon_can('nfc_cart_struct') &&
      !_vm.ribbon_can('nfc_setting_page_struct') &&
      !_vm.ribbon_can('nfc_add_reserve_qr_code')
    )?_c('NfcCartList'):_c('custom-tabs',{staticClass:"ma-5 mt-8",attrs:{"tab-items":_vm.tabs,"window-items":_vm.tabs,"grow":""},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c(item.component,{tag:"component"})]}}]),model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }